<template>
  <v-alert
    dense
    outlined
    color="primary"
    :icon="false"
    class="operation-context-alert"
  >
    <div class="d-flex align-center">
      <v-icon color="primary" class="mr-3">mdi-information</v-icon>
      <div class="operation-context-alert__text">
        <slot />
      </div>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: "OperationContextAlert",
};
</script>

<style scoped>
.operation-context-alert {
  border-color: #5867dd !important;
  color: #5867dd;
}

.operation-context-alert__text {
  color: #5867dd;
  font-size: 14px;
  line-height: 1.45;
}
</style>
